import * as React from 'react';
import { Form, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { ITemplate, IRecipient, IFile, ISmsFormState } from '../../../Types';
import { Translate } from '../../../../../../../shared/LanguageService';
import DateTime from 'react-datetime';
import TemplateSelect from '../../TemplateSelect';
import RecipientSelect from '../../RecipientSelect';
import moment from 'moment';

interface IProps {
    errors: any;
    state: ISmsFormState;
    recipients: IRecipient[];
    templates: ITemplate[];
    onChange: (e: any) => void;
    onDateTimeChange: (moment: any) => void;
    onSelectorChange: (e: any) => void;
}

const SmsForm = (props: IProps) => {
    function errorExists(errors: any, key: string) {
        if (errors && errors[key]) {
            return true;
        }

        return false;
    }

    return (
        <Form>
            <FormGroup>
                <RecipientSelect
                    onChange={props.onSelectorChange}
                    recipients={props.recipients}
                    recipient={props.state.recipient}
                    errors={props.errors}
                />
            </FormGroup>

            <FormGroup validationState={errorExists(props.errors, 'ccs') ? 'error' : null}>
                <ControlLabel>
                    {Translate('view-order/basic-order/modal/create-email/form/cc')}
                </ControlLabel>
                <FormControl
                    type="text"
                    name="cc"
                    value={props.state.cc}
                    onChange={props.onChange}
                />
                {props.errors && <HelpBlock>{props.errors.ccs}</HelpBlock>}
            </FormGroup>

            <FormGroup validationState={errorExists(props.errors, 'when') ? 'error' : null}>
                <ControlLabel>
                    {Translate('view-order/basic-order/modal/create-email/form/when')}
                </ControlLabel>
                <DateTime locale={moment.locale()} onChange={props.onDateTimeChange} />
                {props.errors && <HelpBlock>{props.errors.when}</HelpBlock>}
            </FormGroup>

            <FormGroup>
                <TemplateSelect
                    onChange={props.onSelectorChange}
                    templates={props.templates}
                    template={props.state.template}
                />
            </FormGroup>

            <FormControl
                componentClass="textarea"
                name="body"
                value={props.state.body}
                onChange={props.onChange}
            />
        </Form>
    );
};

export default SmsForm;
